import React, { useCallback } from 'react';
import { useRouter } from 'next/router';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
// import { useSelector } from 'react-redux';
// import { selectByFiler } from 'redux-api/reselect/config';
// import DateSelector from 'components/filters/date-selector';
import Filters from './filters';
import Table from '../default';

const Wrapper = styled.div`
  background-color: ${themeGet('colors.white')};
  border: 2px solid ${themeGet('colors.primary_100')};
  border-radius: 12px;

  & > .table-head {
    height: 88px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    border-bottom: 2px solid ${themeGet('colors.primary_100')};
    padding: 0 ${themeGet('space.s')}px;
  }
`;

function BillingTable({
  emptyLabel,
  onChangeTable,
  invoicesType,
  onChangeInvoicesType,
  dataSource,
  columns,
  pagination,
  loading,
  languageCode,
}) {
  const { push } = useRouter();

  // const { compare, dataType, dateRange, dates } = useSelector((state) => state.filters);
  // const selectByFilter = useSelector((state) => selectByFiler(state));

  const handleClickRow = useCallback(
    ({ id, typologyCode, status, platformDashCode }) => ({
      onClick: () => {
        if (typologyCode === 'ACTIVE' && platformDashCode === 'PUBLISH') {
          return false;
        }

        if (typologyCode === 'ACTIVE') {
          return push({ pathname: '/billing/active', query: { id } });
        }

        if (status === 'DRAFT') {
          return push({ pathname: '/billing/draft', query: { id } });
        }

        return push({ pathname: '/billing/passive', query: { id } });
      },
      style: {
        cursor: typologyCode === 'ACTIVE' && platformDashCode === 'PUBLISH' ? 'not-allowed' : 'pointer'
      }
    }),
    [push],
  );

  const handleChangeInvoicesType = useCallback(
    (value) => {
      onChangeInvoicesType(value);
    },
    [onChangeInvoicesType],
  );

  return (
    <Wrapper>
      <div className="table-head">
        <div className="left">
          <Filters
            languageCode={languageCode}
            selected={invoicesType}
            setSelected={handleChangeInvoicesType}
          />
        </div>
        <div className="right">
          {/* <DateSelector
            noShowCompare
            dates={dates}
            selectByFilter={selectByFilter}
            languageCode={languageCode}
            dateRange={dateRange}
            dataType={dataType}
            compare={compare}
            direction="right"
          /> */}
        </div>
      </div>

      <Table
        emptyLabel={emptyLabel}
        onChangeTable={onChangeTable}
        dataSource={dataSource}
        columns={columns}
        pagination={pagination}
        loading={loading}
        onRow={handleClickRow}
      />
    </Wrapper>
  );
}

export default BillingTable;
